"use client";

/**
 * Custom image loader for static exports.
 *
 * When `output: "export"` is set with a basePath (e.g. /ciab2026),
 * `next/image` with `unoptimized: true` does NOT prepend basePath to src.
 * Using `loader: "custom"` + this loaderFile lets us serve the original
 * files and still resolve correct paths on the static host.
 *
 * NEXT_PUBLIC_BASE_PATH is inlined at build time by the export script.
 */
export default function imageLoader({
  src,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH || "";
  if (basePath && !src.startsWith(basePath)) {
    return `${basePath}${src}`;
  }
  return src;
}
